module.exports = __webpack_public_path__ + "img/bianca.3b175c67.png";